import React, { createContext, useState, useContext, useEffect } from "react";
import { auth, db } from "../config/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

// Array of admin emails
const ADMIN_EMAILS = [
  "new@gmail.com",
  "admin@azboysgymnastics.com",
  "admin@gmail.com",
  "test@test.com",
  "admin@example.com",
  "admin@test.com",
  // Add the email you're using to log in here
];

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setUser(user);
      console.log("=== Auth State Changed ===");
      console.log("Current user:", user?.email);
      
      // Check if user is in admin emails list
      const isEmailAdmin = user?.email ? ADMIN_EMAILS.includes(user.email) : false;
      console.log("Is admin by email?:", isEmailAdmin);
      
      // If user exists, check Firestore for admin role
      let isRoleAdmin = false;
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            // Check if user has admin role or isAdmin flag
            isRoleAdmin = userData.role === 'admin' || userData.isAdmin === true;
            console.log("Is admin by role?:", isRoleAdmin);
          }
        } catch (error) {
          console.error("Error checking admin status:", error);
        }
      }
      
      // User is admin if either email is in admin list or role is admin
      setIsAdmin(isEmailAdmin || isRoleAdmin);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    user,
    isAdmin,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
